
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advisors",
      function () {
        return require("private-next-pages/advisors/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advisors"])
      });
    }
  